import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Breadcrumb } from '@sravni/react-design-system';
import { Html, Reviews } from '@sravni/react-seo';

import {
  SravniReviewsEnumsReviewObjectType,
  SravniReviewsEnumsReviewRateStatus,
} from '@__generated__/reviews/reviewsApiTypes';
import { OrganizationType, OrganizationTypeToOrganizationReviewsMap } from '@constants/organizationType';
import { useReviews } from '@store/hooks/reviews';
import { useFingerprint } from '@store/hooks/users';
import { fetchReviews } from '@store/reducers/reviews';

import { useOrganizationType } from '../../hooks/organizationType';
import { useMetadataByPath } from '../../hooks/useMetadataByPath';

import styles from './seo-blocks.module.scss';

const ALL_REVIEWS_LINK: Record<OrganizationType, string> = {
  [OrganizationType.BANK]: '/banki/otzyvy/',
  [OrganizationType.INSURANCE_COMPANY]: '/strakhovye-kompanii/otzyvy/',
  [OrganizationType.MFI]: '/zaimy/otzyvy/',
  [OrganizationType.COURSES]: '/kursy/otzyvy/',
  [OrganizationType.BROKER]: '/brokery/otzyvy/',
  [OrganizationType.NPF]: '/npf/otzyvy/',
  [OrganizationType.UNIVERSITY]: '/university/otzyvy/',
  [OrganizationType.BOOKMAKER]: '/bukmekery/otzyvy/',
};

export const SeoBlocks: React.FC = React.memo(() => {
  const organizationType = useOrganizationType();
  const metadata = useMetadataByPath();

  const { breadcrumbs = [], contentBlocks = [] } = metadata ?? {};
  const dispatch = useDispatch();
  const reviews = useReviews();
  const fp = useFingerprint();

  // @ts-ignore
  const htmlText = contentBlocks.find((block) => block.type === 'html')?.text;

  useEffect(() => {
    if (reviews) return;

    dispatch(
      fetchReviews({
        ReviewObjectType: organizationType as unknown as SravniReviewsEnumsReviewObjectType,
        NewIds: true,
        RateStatus: SravniReviewsEnumsReviewRateStatus.RateApproved,
        fingerPrint: fp,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationType, reviews]);

  return (
    <>
      {reviews?.length > 0 ? (
        <div className={styles.reviewsWrapper}>
          <Reviews
            heading={'Отзывы'}
            reviews={reviews}
            productType={OrganizationTypeToOrganizationReviewsMap[organizationType]}
            allReviewsLink={ALL_REVIEWS_LINK[organizationType]}
            gradient={true}
            className={'h-mt-32'}
          />
        </div>
      ) : null}
      {!!breadcrumbs?.length && (
        <div className={classNames(styles.breadcrumbs, 'h-mt-40')}>
          <Breadcrumb>
            {breadcrumbs.map(({ url, title }) => (
              <Breadcrumb.Item href={url} key={url}>
                {title}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      )}
      {htmlText && <Html text={htmlText} className={'h-mt-36'} />}
    </>
  );
});
